const TCSFreshs = () => {
    return (
      <div>
          <div className="flex flex-col justify-center items-center">
          <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
             
              <div className="flex flex-col justify-center">
                <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                    TCS Fresh
                </h1>
                <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                  TCS Fresh aims to deliver seasonal farm fresh fruits and vegetables across Pakistan. As a 
                  farm-to-table supply chain solution, bringing quality produce to customers’ homes, we are the partner 
                  of choice for farmers as we support their growth by connecting them to the customers’ doorstep. Our extensive 
                  network across Pakistan also allows customers to send favourite seasonal fruits to their loved ones, 
                  wherever they may be.
                </p>
              </div>
              <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                <img src="/DomesticScrollingBanner/image16.jpg" alt="" className="rounded-md max-w-[100%]"/>
              </div>
            </div>
          
          </div>
        </div>
    
    )
};
export default TCSFreshs;